import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  width: 100%;
`;
